export default function($) {
  const timing = 1000,
        countdownContainer = $('.js-countdown'),
        countdownDaysElement = $('#countdown-days'),
        countdownHoursElement = $('#countdown-hours'),
        countdownMinutesElement = $('#countdown-minutes');


  if (countdownContainer.length  > 0 && ( countdownDaysElement.length > 0 || countdownHoursElement.length > 0 || countdownMinutesElement.length > 0 )) {
    setInterval(updateCountdown, timing);
  }

  function formatNumber(number) {
    return number < 10 ? `0${number}` : number.toString();
  }

  function updateCountdown() {
    const countdownContainer = $('.js-countdown'),
          targetDate = countdownContainer.data('datestart'),
          targetTime = new Date(targetDate).getTime(),
          currentTime = new Date().getTime(),
          timeDifference = targetTime - currentTime;

    if (timeDifference <= 0) {
      // La date est déjà passée.
      $('#countdown-days').text('00');
      $('#countdown-hours').text('00');
      $('#countdown-minutes').text('00');
      return;
    }

    const oneMinute = 60 * 1000,
          oneHour = oneMinute * 60,
          oneDay = oneHour * 24;

    const days = Math.floor(timeDifference / oneDay),
          hours = Math.floor((timeDifference % oneDay) / oneHour),
          minutes = Math.floor((timeDifference % oneHour) / oneMinute);

    const formattedDays = formatNumber(days),
          formattedHours = formatNumber(hours),
          formattedMinutes = formatNumber(minutes);

    $('#countdown-days').text(formattedDays);
    $('#countdown-hours').text(formattedHours);
    $('#countdown-minutes').text(formattedMinutes);
  }
}
